/*
 * ICOFFEE product page: gallery, size pills, quantity, Add to cart / Buy now (through window.IcCart),
 * the details tabs and the bundle offer.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function toast(message) {
    if (message && window.IcAccount && window.IcAccount.toast) window.IcAccount.toast(message, { tone: 'error' });
  }

  // assets/ic-cart.js loads deferred as well; wait for it instead of depending on script order
  function cart() {
    return new Promise(function (resolve) {
      if (window.IcCart) return resolve(window.IcCart);
      var tries = 0;
      var timer = setInterval(function () {
        if (window.IcCart || ++tries > 60) {
          clearInterval(timer);
          resolve(window.IcCart || null);
        }
      }, 50);
    });
  }

  /* ---------- gallery ---------- */

  document.querySelectorAll('[data-ic-pd-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-ic-pd-slide]');
    var thumbs = gallery.querySelectorAll('[data-ic-pd-thumb]');

    function show(index) {
      slides.forEach(function (slide) {
        var on = slide.dataset.icPdSlide === String(index);
        slide.classList.toggle('is-active', on);
        var video = slide.querySelector('video');
        if (video && !on) video.pause();
        if (video && on) video.play().catch(function () {});
      });
      thumbs.forEach(function (thumb) {
        if (thumb.dataset.icPdThumb === String(index)) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb.dataset.icPdThumb); });
    });
  });

  /* ---------- buy box ---------- */

  var root = document.querySelector('[data-ic-pd]');
  var form = root && root.querySelector('[data-ic-pd-form]');

  if (form) {
    var variant = form.querySelector('[data-ic-pd-variant]');
    var qty = form.querySelector('[data-ic-pd-qty-value]');
    var add = form.querySelector('.ic-pd__add');
    var buy = form.querySelector('[data-ic-pd-buy]');
    var price = root.querySelector('.ic-pd__price');

    var quantity = function () {
      var n = parseInt(qty.value, 10);
      return n > 0 ? Math.min(n, 99) : 1;
    };

    form.addEventListener('click', function (e) {
      var step = e.target.closest('[data-ic-pd-qty]');
      if (step) {
        qty.value = Math.max(1, Math.min(99, quantity() + Number(step.dataset.icPdQty)));
        return;
      }

      var size = e.target.closest('button.ic-pd__size');
      if (size && !size.disabled) {
        form.querySelectorAll('button.ic-pd__size').forEach(function (b) { b.setAttribute('aria-checked', String(b === size)); });
        variant.value = size.dataset.id;
        // each size shows its own pack: the can for 250g, the tin for 125g
        if (size.dataset.art) root.querySelectorAll('[data-ic-pd-art]').forEach(function (img) { img.src = size.dataset.art; });
        root.querySelector('[data-ic-pd-price]').textContent = size.dataset.price;
        root.querySelector('[data-ic-pd-compare]').textContent = size.dataset.compare;
        root.querySelector('[data-ic-pd-was]').hidden = !size.dataset.compare;
        var save = root.querySelector('[data-ic-pd-save]');
        save.textContent = size.dataset.save;
        save.hidden = !size.dataset.save;
        // ICOFFEE points this size earns (only while points are on)
        var points = root.querySelector('[data-ic-pd-points]');
        if (points && size.dataset.points) {
          points.querySelector('span').innerHTML = points.dataset.template.replace('[points]', String(Number(size.dataset.points)));
          points.hidden = Number(size.dataset.points) === 0;
        }
        price.classList.remove('is-bumped');
        void price.offsetWidth;
        price.classList.add('is-bumped');
        var url = new URL(location.href);
        url.searchParams.set('variant', size.dataset.id);
        history.replaceState(null, '', url);
      }
    });

    qty.addEventListener('change', function () { qty.value = quantity(); });

    // arrow keys move between sizes, like native radios
    form.addEventListener('keydown', function (e) {
      var size = e.target.closest('button.ic-pd__size');
      if (!size || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
      var pills = Array.prototype.filter.call(size.parentNode.children, function (b) { return !b.disabled; });
      var forward = e.key === 'ArrowDown' || e.key === (document.documentElement.dir === 'rtl' ? 'ArrowLeft' : 'ArrowRight');
      var next = pills[(pills.indexOf(size) + (forward ? 1 : -1) + pills.length) % pills.length];
      e.preventDefault();
      next.focus();
      next.click();
    });

    var send = function (button, open) {
      if (button.getAttribute('aria-busy') === 'true') return Promise.reject();
      button.setAttribute('aria-busy', 'true');
      return cart()
        .then(function (api) {
          if (!api) {
            form.submit();
            return Promise.reject();
          }
          return api.add([{ id: variant.value, quantity: quantity() }], { open: open });
        })
        .finally(function () { button.removeAttribute('aria-busy'); });
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      send(add, true)
        .then(function () {
          var label = add.querySelector('span');
          var original = label.textContent;
          add.classList.add('is-added');
          label.textContent = add.dataset.added;
          setTimeout(function () {
            add.classList.remove('is-added');
            label.textContent = original;
          }, 1600);
        })
        .catch(function () {});
    });

    buy.addEventListener('click', function () {
      send(buy, false)
        .then(function () { location.href = root.dataset.checkoutUrl || '/checkout'; })
        .catch(function () {});
    });
  }

  /* ---------- details tabs ---------- */

  document.querySelectorAll('[data-ic-tabs]').forEach(function (tabs) {
    var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
    var panels = tabs.querySelectorAll('[role="tabpanel"]');

    function select(button, focus) {
      buttons.forEach(function (b) {
        var on = b === button;
        b.setAttribute('aria-selected', String(on));
        b.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var on = panel.id === button.getAttribute('aria-controls');
        panel.hidden = !on;
        if (on && !reduce.matches) {
          panel.classList.remove('is-enter');
          void panel.offsetWidth;
          panel.classList.add('is-enter');
        }
      });
      if (focus) button.focus();
      // keep the chosen tab in view when the list scrolls sideways on phones
      button.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () { select(button, false); });
      button.addEventListener('keydown', function (e) {
        var i = buttons.indexOf(button);
        var rtl = document.documentElement.dir === 'rtl';
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var dir = (e.key === 'ArrowRight') !== rtl ? 1 : -1;
          e.preventDefault();
          select(buttons[(i + dir + buttons.length) % buttons.length], true);
        } else if (e.key === 'Home') {
          e.preventDefault();
          select(buttons[0], true);
        } else if (e.key === 'End') {
          e.preventDefault();
          select(buttons[buttons.length - 1], true);
        }
      });
    });
  });

  /* ---------- bundle offer ---------- */

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-ic-bundle-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    // one id for the three coffees: the cart shows lines that share it as a single bundle (snippets/ic-cart-bundle)
    var bundle = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var items = button.dataset.icBundleAdd.split(',').filter(Boolean).map(function (id) { return { id: id, quantity: 1, properties: { _bundle: bundle } }; });
    button.setAttribute('aria-busy', 'true');
    cart()
      .then(function (api) {
        if (!api) throw new Error('no_cart');
        return api.add(items);
      })
      .catch(function (err) { if (err && err.message === 'no_cart') toast(button.dataset.error); })
      .finally(function () { button.removeAttribute('aria-busy'); });
  });
})();
